import { t } from "@repo/translation";

export const getCalendarTourSteps = () => {
  return [
    {
      disableBeacon: true,
      target: "ul > li:nth-child(2)",
      content: t("tour.projects_overview.step2"),
    },
    {
      target: "#tour-calendar-container .saleslead__toggle__button:first-child",
      content: t("tour.calendar.step2"),
    },
    {
      target:
        "#tour-calendar-container .saleslead__toggle__button:nth-child(2)",
      content: t("tour.calendar.step3"),
    },
    {
      target:
        "#tour-calendar-container .saleslead__toggle__button:nth-child(3)",
      content: t("tour.calendar.step4"),
    },
    {
      target: "#tour-calendar-container + div",
      content: t("tour.calendar.step5"),
    },
    {
      target: "#tour-search-field",
      content: t("tour.calendar.step6"),
    },
    {
      target: ".tour-popper-portal input[type='checkbox']",
      content: t("tour.calendar.step7"),
    },
    {
      target: "#tour-calendar-new-button",
      content: t("tour.calendar.step8"),
    },
    {
      target: "#tour-calendar-assignee-task",
      content: t("tour.calendar.step9"),
    },
    {
      target: "#tour-calendar-type-select",
      content: t("tour.calendar.step10"),
    },
    {
      target: "#tour-calendar-task-tite",
      content: t("tour.calendar.step11"),
    },
    {
      target: "#tour-calendar-dates",
      content: t("tour.calendar.step12"),
    },
    {
      target: "#tour-calendar-task-all-day",
      content: t("tour.calendar.step13"),
    },
  ];
};
